import LoadPanel from 'app/components/LoadPanel';
import useAxios from 'axios-hooks';
import { APP_NAME, LANG_DEFAULT } from 'constant';
import { router } from 'constant/router';
import { Button, Form, Template } from 'devextreme-react';
import { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { notification } from 'utils/notification';
import { valid } from 'utils/validation';
import { useSignUp } from '..';
import { requiredMessage } from 'utils/messages';

const eye = 'fas fa-eye';
const eyeSlash = 'fas fa-eye-slash';

function FormCreate() {
  const context: any = useSignUp();
  const { t } = context;
  const formRef: any = useRef(null);
  const { regexPassword } = valid;
  const history = useHistory();
  const [formData] = useState<any>({
    email: '',
    userName: '',
    password: '',
    confirmPassword: '',
    company: '',
    loginId: '',
  });
  const [viewPassword, setViewPassword] = useState({
    password: false,
    conPassword: false,
  });

  const [{ loading }, fetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  const handleSubmit = async () => {
    const isValid = formRef?.current?.instance?.validate()?.isValid;
    if (!isValid) return;
    const lang =
      JSON.parse(localStorage.getItem('myPagePreference') ?? '{}')?.language ??
      LANG_DEFAULT;
    const dataRequest = {
      ...formData,
      loginId: formData?.loginId?.toLowerCase?.()?.trim(),
      lang,
    };
    const res = await fetchData({
      url: '/user-singup/create-user-company',
      method: 'PUT',
      data: dataRequest,
    });
    notification({ res });
    if (res?.data?.status === '201') {
      return history.push(router.login);
    }
    // history.push({
    //   pathname: history.location.pathname,
    //   search: '?verification-code',
    // });
    // if (res?.data?.status === '201') {
    //   tokenService.updateLocalUserRegistration({ email: data.email });
    //   history.push({
    //     pathname: history.location.pathname,
    //     search: '?verification-code',
    //   });
    // } else if (res?.data?.status === '427') {
    //   tokenService.updateLocalUserRegistration({ email: data.email });
    //   history.push({
    //     pathname: history.location.pathname,
    //     search: '?resend-code',
    //   });
    // }
  };

  const passwordRequired: any = o => {
    return {
      type: 'custom',
      validationCallback: (e: any) => {
        const { value } = e;
        if (!value) {
          return false;
        } else if (o && !value) {
          return false;
        } else {
          return true;
        }
      },
      message: t('Password is required'),
    };
  };
  const passwordMatch: any = {
    type: 'custom',
    validationCallback: (e: any) => {
      if (!e?.value) return true;
      const { value } = e;
      if (formData?.password === value) return true;
      return false;
    },
    message: t('The password does not match'),
  };

  const passwordValid = {
    type: 'custom',
    validationCallback: (e: any) => {
      const { value } = e;
      if (!value) return true;
      return regexPassword(value);
    },
    message: t(
      'The password must contain at least 8 characters including number, letter, special character',
    ),
  };

  return (
    <div className="sign-up-form">
      <LoadPanel visible={loading} />
      <div className="header">
        <div className="sing-up">{t('Sign Up')}</div>
        <div className="sub-sing-up">{`${t('Welcome To')} ${APP_NAME}!`}</div>
      </div>
      <div className="form-content-input">
        <Form
          formData={formData}
          ref={formRef}
          showColonAfterLabel={false}
          items={[
            {
              label: { text: t('Full Name') },
              dataField: 'userName',
              editorType: 'dxTextBox',
              validationRules: [
                { type: 'stringLength', max: 256 },
                { type: 'required', message: requiredMessage(t('Full Name')) },
              ],
              editorOptions: {
                inputAttr: { autoComplete: 'off' },
              },
            },
            {
              label: { text: t('E-mail') },
              dataField: 'email',
              editorType: 'dxTextBox',
              editorOptions: {
                mode: 'email',
                inputAttr: { autoComplete: 'off' },
              },
              validationRules: [
                { type: 'email' },
                { type: 'required', message: requiredMessage(t('E-mail')) },
              ],
            },
            {
              label: { text: t('User Name') },
              dataField: 'loginId',
              editorType: 'dxTextBox',
              validationRules: [
                { type: 'stringLength', max: 50 },
                { type: 'required', message: requiredMessage(t('User Name')) },
              ],
              editorOptions: {
                inputAttr: { autoComplete: 'off' },
              },
            },
            {
              itemType: 'group',
              colCount: 2,
              items: [
                {
                  label: { text: t('Password') },
                  dataField: 'password',
                  editorType: 'dxTextBox',
                  editorOptions: {
                    inputAttr: { autoComplete: 'new-password' },
                    mode: viewPassword?.password ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.password ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              password: !preState.password,
                            })),
                        },
                      },
                    ],
                  },
                  validationRules: [
                    passwordRequired(formData?.confirmPassword),
                    passwordValid,
                    { type: 'required' },
                  ],
                },
                {
                  label: { text: t('Confirm Password') },
                  dataField: 'confirmPassword',
                  editorType: 'dxTextBox',
                  editorOptions: {
                    mode: viewPassword?.conPassword ? 'text' : 'password',
                    buttons: [
                      {
                        name: 'view',
                        location: 'after',
                        options: {
                          stylingMode: 'text',
                          icon: viewPassword?.conPassword ? eye : eyeSlash,
                          onClick: () =>
                            setViewPassword(preState => ({
                              ...preState,
                              conPassword: !preState.conPassword,
                            })),
                        },
                      },
                    ],
                  },
                  validationRules: [
                    passwordRequired(formData?.password),
                    passwordValid,
                    passwordMatch,
                  ],
                  isRequired: true,
                },
              ],
            },
            {
              itemType: 'empty',
              dataField: 'password',
              editorType: 'dxTextBox',
              label: {
                text: t('Password'),
              },
              editorOptions: {
                mode: viewPassword?.password ? 'text' : 'password',
                buttons: [
                  {
                    name: 'view',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: viewPassword?.password ? eye : eyeSlash,
                      onClick: () =>
                        setViewPassword(preState => ({
                          ...preState,
                          password: !preState.password,
                        })),
                    },
                  },
                ],
              },
              validationRules: [
                passwordRequired(formData?.confirmPassword),
                passwordValid,
              ],
              isRequired: true,
            },
            {
              itemType: 'empty',
              dataField: 'confirmPassword',
              editorType: 'dxTextBox',
              label: {
                text: t('Confirm Password'),
              },
              editorOptions: {
                mode: viewPassword?.conPassword ? 'text' : 'password',
                buttons: [
                  {
                    name: 'view',
                    location: 'after',
                    options: {
                      stylingMode: 'text',
                      icon: viewPassword?.conPassword ? eye : eyeSlash,
                      onClick: () =>
                        setViewPassword(preState => ({
                          ...preState,
                          conPassword: !preState.conPassword,
                        })),
                    },
                  },
                ],
              },
              validationRules: [
                passwordRequired(formData?.password),
                passwordValid,
                passwordMatch,
              ],
              isRequired: true,
            },
            {
              label: { text: t('Company Name') },
              dataField: 'company',
              editorType: 'dxTextBox',
              validationRules: [
                { type: 'stringLength', max: 256 },
                {
                  type: 'required',
                  message: requiredMessage(t('Company Name')),
                },
              ],
            },
          ]}
          labelLocation="top"
          colCount={1}
        ></Form>
        <div style={{ marginTop: 20 }}>
          <Button
            stylingMode="contained"
            type="default"
            text={t('Sign Up')}
            style={{ marginRight: 5, width: '100%' }}
            onClick={handleSubmit}
          />
        </div>
      </div>

      <br />
      <div className="create-account-signup">
        <span>{t('Already have an account?')}</span>
        <span onClick={() => history.push('/login')}> {t('Login')}</span>
      </div>
    </div>
  );
}

export default FormCreate;
